<template>
  <div id="EdicionProcesado_div">
    <div id="encabezado-" class="form-inline justify-content-between">
      <h5>{{tituloDeInformacion}}</h5>
    </div>
    <hr class="mt-2" />
    <div >
      

        <!-- <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xlg-4 mb-4 ml-0 pl-1">     
          <h6>Clave del Procesado</h6>
          <input :class="'catalogoInformativo'" class="form-control" type="text" placeholder="." v-model="clave_del_procesado" id="clave_del_procesado" />
        </div> -->

        <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xlg-4 mb-4 ml-0 pl-1">
          <h6>Clave del Procesado:</h6>

          <h6 :class="'catalogoInformativo'">{{clave_del_procesado}}</h6>
         
        </div>




            <div class="row">
    <div v-for="catalogo in catalogos" :key="catalogo.catalogoId" class="col-12">     
      <div v-if="catalogo.catalogoId != undefined && catalogo.catalogoId != null">  
        
        
         <div v-if="catalogo.catalogoId == enumeraciones.catalogos.Municipios"  id="Municipios_div">
          <h6>Municipios</h6>
          <C010Municipios 
            :class="[parametros_Municipio.esInformativo ? 'catalogoInformativo' : '']" 
            v-on:valorParaElPadre="cambioDeMunicipioEvento" 
            v-on:valorParaElPadrePrimerElemento="cambioDeMunicipio" 
            :prefijo="catalogo.etiquetaDeHtml" 
            :tipo="catalogo.tipoDeSelect" 
            :idDelInput="catalogo.idDelInput" 
            :parametros="parametros_Municipio.parametros" 
            :valorDefinido="parametros_Municipio.municipioId" 
            :key="parametros_Municipio.key">
          </C010Municipios>
        </div>


         <div v-if="catalogo.catalogoId == enumeraciones.catalogos.Entidades"  id="Entidades_div">
          <h6>Entidades Federativas</h6>
          <C011EntidadesFederativas 
            :class="[parametros_Entidades.esInformativo ? 'catalogoInformativo' : '']" 
            v-on:valorParaElPadre="cambioDeEntidadEvento" 
            v-on:valorParaElPadrePrimerElemento="cambioDeEntidad" 
            :prefijo="catalogo.etiquetaDeHtml" 
            :tipo="catalogo.tipoDeSelect" 
            :idDelInput="catalogo.idDelInput" 
            :parametros="parametros_Entidades.parametros" 
            :valorDefinido="parametros_Entidades.entidadId" 
            :key="parametros_Entidades.key">
          </C011EntidadesFederativas>
        </div>




       </div>


       </div>


      
           
    <div class="col-12 form-group" id="nombre_div">     
          <h6>Nombre(s)</h6>
          <input class="form-control" type="text" placeholder="Ingrese el nombre" v-model="nombre" id="nombre" @input="(text) => (nombre = nombre.toUpperCase())" @keypress="esLetra($event)" />
    </div>

    <div class="col-12 form-group" id="apellido_paterno_div">
          <h6>Apellido Paterno</h6>
          <input class="form-control" type="text" placeholder="Ingrese el apellido paterno (al menos un apellido)" v-model="apellido_paterno" id="apellido_paterno" @input="(text) => (apellido_paterno = apellido_paterno.toUpperCase())" @keypress="esLetra($event)"  />
    </div>

    <div class="col-12 form-group" id="apellido_materno_div">
          <h6>Apellido Materno</h6>
          <input class="form-control" type="text" placeholder="Ingrese el apellido materno (al menos un apellido)" v-model="apellido_materno" id="apellido_materno" @input="(text) => (apellido_materno = apellido_materno.toUpperCase())" @keypress="esLetra($event)" />
    </div>

    <div class="col-12 form-group" id="nota_div">     
          <h6>Nota: si el procesado cuenta con solo un apellido no ingresar nada en el campo del otro apellido</h6>
          
    </div>




<!--     <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xlg-4 mb-4 ml-0 pl-1">     
          <h6>Nombre(s)</h6>
          <input class="form-control" type="text" placeholder="Ingrese el nombre" v-model="nombre" id="nombre" />
        </div>

        <div v-if="(apellido_paterno == undefined || apellido_paterno == null)" class="col-12 col-sm-12 col-md-6 col-lg-6 col-xlg-4 mb-4 ml-0 pl-1">
          <h6>Apellido Paterno</h6>
          <input :class="'catalogoInformativo'" class="form-control" type="text" placeholder="El Procesado no cuenta con apellido paterno" v-model="apellido_paterno" id="apellido_paterno" />
        </div>

        <div v-else-if="(apellido_paterno != undefined && apellido_paterno != null)" class="col-12 col-sm-12 col-md-6 col-lg-6 col-xlg-4 mb-4 ml-0 pl-1">
          <h6>Apellido Paterno</h6>
          <input class="form-control" type="text" placeholder="Ingrese el apellido paterno" v-model="apellido_paterno" id="apellido_paterno" />
        </div>
          
        <div v-if="(apellido_materno == undefined || apellido_materno == null)" class="col-12 col-sm-12 col-md-6 col-lg-6 col-xlg-4 mb-4 ml-0 pl-1">
          <h6>Apellido Materno</h6>
          <input :class="'catalogoInformativo'" class="form-control" type="text" placeholder="El Procesado no cuenta con apellido materno" v-model="apellido_materno" id="apellido_materno" />
        </div>

        <div v-else-if="(apellido_materno != undefined && apellido_materno != null)" class="col-12 col-sm-12 col-md-6 col-lg-6 col-xlg-4 mb-4 ml-0 pl-1">
          <h6>Apellido Materno</h6>
          <input class="form-control" type="text" placeholder="Ingrese el apellido materno" v-model="apellido_materno" id="apellido_materno" />
        </div>  -->






    <div class="col-12 form-group" id="direccion_div">
          <h6>Dirección</h6>
          <input class="form-control" type="text" placeholder="Ingrese la direccion" v-model="direccion" id="direccion" @input="(text) => (direccion = direccion.toUpperCase())" @keypress="esDireccion($event)" />
    </div>

   
    

            <!-- Botones guardar y cancelar -->
    <div class="d-flex row">
        <div  class="col-12 form-group">
            
             <button type="button" v-if="camposLlenos()" class="btn btn-success overwrapDeBotones mr-3"  @click="GuardarEdicionProcesado()"><i class="fas fa-save fa-lg"></i>&nbsp;&nbsp;Guardar</button>

             <button type="button" class="btn btn-danger overwrapDeBotones mr-3"  @click="Botoncancelar()"><i class="fas fa-window-close fa-lg"></i>&nbsp;&nbsp;Cancelar</button>

        </div>


        <div class="d-sm-none d-md-none d-lg-block col-lg-1 col-xlg-1"></div>
        
    </div>


        <div class="d-sm-none d-md-none d-lg-block col-lg-1 col-xlg-1"></div>



        
    </div>




















      




  </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import enumeraciones from '@/../static/js/enumeraciones'
  import comun from '@/../static/js/comun'
  import catalogos from '@/../static/js/catalogos'
  import { mapActions } from 'vuex'
  import VueMask from 'v-mask'
  import axios from 'axios'
  import api from '@/../static/js/api'
  import func from '../Comun/Funciones/comun.js'

  Vue.use(VueMask);

  export default {
    data() {
      return {
        togglePerspectivaRender: 1,
        enumeraciones,
        tipoEstatusFirmaId:-1,
        partidoJudicialId: -1,
        materiaId: -1,
        delitoId: -1,
        rubroId: -1,
        areaId: -1,
        tipoDocumentoId: -1,
        temporalidadId: -1,



        parametros_Entidades: {
        key: "",
        entidadId: 1,   //entidadFederativaId es entidadId
        parametros: {},
          esInformativo: false
       },
        parametros_Municipio: {
        key: "",
        municipioId: -1,
        parametros: {},
          esInformativo: false
       },




        nombre:null,
        apellido_paterno: null,
        apellido_materno: null,
        direccion: null,
        consecutivo: null,
        
       }  
              

    },
    props: {
      esAlta:true,
      tituloDeInformacion: String,
      EdiciondeProcesados:Object,
      catalogos: Array,
      elementosAOmitir: Object,
      elementosAConservar: Object,
      area: null
    },
    components: {
      C008TiposEstatusFirma: catalogos.SIVAC.C008TiposEstatusFirma,
      C009PartidosJudiciales: catalogos.PJ.C009PartidosJudiciales,
      C002Materias: catalogos.PJ.C002Materias,
      C001Area: catalogos.PJ.C001Area,
      C004TiposDocumento: catalogos.PJ.C004TipoDocumento,
      C008Delitos: catalogos.PJ.C008Delitos,
      C006TiposRubro: catalogos.SIVAC.C006TiposRubro,
      C010Municipios: catalogos.PJ.C010Municipios,
      C011EntidadesFederativas: catalogos.PJ.C011EntidadesFederativas,
      C009TiposTemporalidad: catalogos.SIVAC.C009TiposTemporalidad,
    },
    /**
     * Método encargado de cargar valores predetermidados en caso de haberlos.
     */
    beforeMount() { 
      
      if(this.EdiciondeProcesados.ClaveDelProcesado)
        this.clave_del_procesado = this.EdiciondeProcesados.ClaveDelProcesado;


      if(this.EdiciondeProcesados.EntidadFederativaId)
        this.parametros_Entidades.entidadId = this.EdiciondeProcesados.EntidadFederativaId;
         this.cambioDeEntidad(parseInt(this.parametros_Entidades.entidadId));


      if(this.EdiciondeProcesados.MunicipioId)
        this.parametros_Municipio.municipioId = this.EdiciondeProcesados.MunicipioId;


      if(this.EdiciondeProcesados.Nombre)
        this.nombre = this.EdiciondeProcesados.Nombre;

      if(this.EdiciondeProcesados.ApellidoPaterno)
        this.apellido_paterno = this.EdiciondeProcesados.ApellidoPaterno;
      else this.apellido_paterno= null;

      if(this.EdiciondeProcesados.ApellidoMaterno)
        this.apellido_materno = this.EdiciondeProcesados.ApellidoMaterno;
      else this.apellido_materno= null;




      // if(this.EdiciondeProcesados.PartidoJudicialId)
      //   this.partidoJudicialId = this.EdiciondeProcesados.PartidoJudicialId;

      // if(this.EdiciondeProcesados.MateriaId)
      //   this.materiaId = this.EdiciondeProcesados.MateriaId;

      // if(this.EdiciondeProcesados.DelitoId_008DBPJ)
      //   this.delitoId = this.EdiciondeProcesados.DelitoId_008DBPJ;

      // if(this.EdiciondeProcesados.AreaId)
      //   this.areaId = this.EdiciondeProcesados.AreaId;

      // if(this.EdiciondeProcesados.TipoDocumentoId)
      //   this.tipoDocumentoId = this.EdiciondeProcesados.TipoDocumentoId;

      // if(this.EdiciondeProcesados.EntidadFederativaId)
      //   this.entidadFederativaId = this.EdiciondeProcesados.EntidadFederativaId;

      // if(this.EdiciondeProcesados.MunicipioId)
      //   this.municipioId = this.EdiciondeProcesados.MunicipioId;

      // if(this.EdiciondeProcesados.TipoTemporalidadId)
      //   this.temporalidadId = this.EdiciondeProcesados.TipoTemporalidadId;

      // if(this.EdiciondeProcesados.Nombre)
      //   this.nombre = this.EdiciondeProcesados.Nombre;

      // if(this.EdiciondeProcesados.ApellidoPaterno)
      //   this.apellido_paterno = this.EdiciondeProcesados.ApellidoPaterno;
      // else this.apellido_paterno= null;

      // if(this.EdiciondeProcesados.ApellidoMaterno)
      //   this.apellido_materno = this.EdiciondeProcesados.ApellidoMaterno;
      // else this.apellido_materno= null;

      if(this.EdiciondeProcesados.Direccion)
        this.direccion = this.EdiciondeProcesados.Direccion;

      // if(this.EdiciondeProcesados.Consecutivo)
      //   this.consecutivo = this.EdiciondeProcesados.Consecutivo;


      
    },



    mounted() {            
             
      
     
     

     
    },




    methods: {
     
      // /** 
      //  * Metodo encargado de obtener el valor del item seleccionado en el catalogo 007TiposEstatusFirma
      //  * @param {object} evento [evento emitido por el catalogo]
      //  */
      // cambioTipoEstatusFirma: function (evento) {
      //   this.tipoEstatusFirmaId = parseInt(evento.target.value);
      // },

      // cambioDePartidoJudicial: function (evento) {
      //   this.partidoJudicialId = parseInt(evento.target.value);
      // },

      // cambioDeMateria: function (evento) {
      //   this.materiaId = parseInt(evento.target.value);
      // },

      // cambioDeDelito: function (evento) {
      //   this.delitoId = parseInt(evento.target.value);
      // },

      // cambioDeArea: function (evento) {
      //   this.areaId = parseInt(evento.target.value);
      // },

      // cambioDeTipoDeDocumento: function (evento) {
      //   this.tipoDocumentoId = parseInt(evento.target.value);
      // },

      // cambioDeEntidad: function (evento) {
      //   this.entidadFederativaId = parseInt(evento.target.value);
      // },

      // cambioDeMunicipio: function (evento) {
      //   this.municipioId = parseInt(evento.target.value);
      // },

      // cambioDeTemporalidad: function (evento) {
      //   this.temporalidadId = parseInt(evento.target.value);
      // },


      /**
       * Método encargado de actualizar/cambiar el campo Municipio
       * @param {event.target} datos [datos: nuevo valor del Municipio]
       */
      cambioDeMunicipioEvento(datos){
        this.cambioDeMunicipio(parseInt(datos.target.value));
      },
      /**
       * Método encargado de actualizar/cambiar el id de Municipio
       * @param {int} id [id: identificador del Municipio]
       */
      cambioDeMunicipio(id){
        this.parametros_Municipio.municipioId = id; 
      },



      /**
       * Método encargado de actualizar/cambiar el campo Entidad
       * @param {event.target} datos [datos: nuevo valor del Entidad]
       */
      cambioDeEntidadEvento(datos){
        this.cambioDeEntidad(parseInt(datos.target.value));
      },
      /**
       * Método encargado de actualizar/cambiar el id de Entidad
       * @param {int} id [id: identificador del Entidad]
       */
      cambioDeEntidad(id){
        this.parametros_Entidades.entidadId = id; 

        //Actualizo municipio
        /**/
        this.parametros_Municipio.municipioId = -1; 
        this.parametros_Municipio.parametros.MunicipioId = -1;   
        this.parametros_Municipio.key += 1;
        /**/
        this.parametros_Municipio.parametros.EntidadFederativaId = id;
        this.parametros_Municipio.key = "EntidadFederativaId_" + id;


      },





      // *
      //  * Método encargado de actualizar/cambiar el campo del Consecutivo.
      //  * @param {event.target} datos [datos: nuevo valor del Consecutivo]
       
      cambioDeConsecutivo(datos) { 
        this.$store.dispatch("A_Comun_Consecutivo", datos.target.value);
      },
      



      /** 
       * Método encargado de llamar API para obtener id's de los tipos de documentos disponibles dependiendo de la base de datos.
       */
      obtenerFiltradoTipoDeDocumentosAPI()
      {
        comun.SeEstaCargandoInformacion(true);                
        
        const parametros = {          
          MateriaId: this.parametros_Materia.materiaId,
          AreaId: this.parametros_Area.areaId,
          EsPrueba: this.enumeraciones.EsPrueba,
        }
        const headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false);        

        axios
          .post(
            api.conexion + api.SIVAC.sistema.administracion.firmas.ObtenerTiposDeDocumentosIdYDBId, 
            parametros, 
            headerPeticion)
          .then(respuesta => 
          {
            comun.SeEstaCargandoInformacion(false);
            if (respuesta.data.SiHayError) 
            {
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else 
            {
              this.parametros_TipoDocumento.parametros.elementosAConservar = respuesta.data.TiposDeDocumentosIds;
              this.baseDeDatosId = respuesta.data.BaseDeDatosId;
              this.parametros_TipoDocumento.key = "elementosAConservar_" + respuesta.data.TiposDeDocumentosIds.length;
            }        
          })
          .catch(e => 
          {
            comun.SeEstaCargandoInformacion(false);
            console.log("No Hay Respuesta del Servidor" + e);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
          });
      },     
      




/////////////////////////////////////////////////////////////////////////////////////////

      /** 
       * Metodo encargado de verificar que todos los campos requeridos estén llenos
       * @param {object} evento [evento emitido por el catalogo]
       */
      camposLlenos:function()
      {
        
        // if (!this.partidoJudicialId || this.partidoJudicialId <= 0) 
        //   return false;

        // if (!this.materiaId || this.materiaId <= 0) 
        //   return false;

        // if (!this.delitoId || this.delitoId <= 0) 
        //   return false;

        // if (!this.areaId || this.areaId <= 0) 
        //   return false;

        // if (!this.tipoDocumentoId || this.tipoDocumentoId <= 0) 
        //   return false;

        // if (!this.entidadFederativaId || this.entidadFederativaId <= 0) 
        //   return false;

        // if (!this.municipioId || this.municipioId <= 0) 
        //   return false;

        // if (!this.temporalidadId || this.temporalidadId <= 0) 
        //   return false;

        // if (!this.nombre || this.nombre <= 0) 
        //   return false;

        if ((!this.apellido_paterno || this.apellido_paterno <= 0) && (!this.apellido_materno || this.apellido_materno <= 0)) 
           return false;

        
        if (!this.direccion || this.direccion <= 0) 
          return false;

        // if (!this.consecutivo || this.consecutivo <= 0) 
        //   return false;



        
        return true;


        // if (!this.apellido_paterno || this.apellido_paterno <= 0) 
        //   return false;

        // if (!this.apellido_materno || this.apellido_materno <= 0) 
        //   return false;






      },
      
      
      /**
       * Función encargada de verificar que el campo proporcionado tenga un valor valido.  
       * @param {string/int/other} campo 
       */
      campoRequeridoEsValido: function(campo) {
          let esValido = false
          if(typeof campo === 'string' || campo instanceof String) {
              // valida que filtro tipo cadena no sea nula, indefinida y compuestas solo de espacios en blanco o saltos de linea
              if (campo != null && campo != undefined && campo != '' && campo.replace(/\s/g, '').length) {
                  esValido = true;
              }
          }
          else if (typeof campo === 'number' || campo instanceof Number) {
              // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
              if (campo != null && campo != undefined && campo > 0) {
                  esValido = true;
              }
          }
          else {
              if (campo != null && campo != undefined) {
                  esValido = true;
              }
          }
          return esValido;
      },

      esDireccion(datos){
        return func.esDireccion(datos)
      },

      esLetra(datos){
        return func.esLetra(datos)
      },

  
      /**
       * Función encargada de llamar a API para guardar una EdiciondeProcesados
       */
      GuardarEdicionProcesado:function()
      {

        var locale = {
        OK: '<i class="fa fa-check"></i>&nbsp;&nbsp;OK',
        CONFIRM: '<i class="fa fa-check"></i>&nbsp;&nbsp;Guardar',
        CANCEL: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
         };
            
       bootbox.addLocale('custom', locale);




          bootbox.prompt({
            title: "Mensaje del sistema",
            message: "Está por guardar la edición del procesado, si decide continuar se guardara la edición para el Procesado. <br> <br />Ingrese el motivo de la edición del procesado: <br>",
            locale: 'custom',
            
            
            callback: (respuestaContinuar) => {
              if (respuestaContinuar) {
               this.$emit('guardar2', respuestaContinuar );
              }
            }
          });



      },



      Botoncancelar:function()
      {

       
     
          bootbox.confirm({
            title: "Mensaje del sistema",
            message: "Está por cancelar la edición del procesado.<br />¿Desea continuar?",
            buttons: {
              cancel: {
                label: '<i class="fa fa-times"></i>&nbsp;&nbsp;No'
              },
              confirm: {
                label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Si'
              }
            },
            callback: (respuestaContinuar) => {
              if (respuestaContinuar) {

                this.$emit("botoncancelar2");

                if(respuestaContinuar){      


                }

                
              }
            }
          });


               

      }
      



    },
    computed: {
     
    }
  }
</script>
<style scoped>
  .contenedor-puntero {
    background: #212529;
    border-radius:2px;
    padding: 10px;
    border:1px solid white;
    margin-bottom: 1.5em;
  }
  .form-control:disabled, .form-control[readonly]
  {
    background-color: #3D3C40 !important;
    pointer-events: none;
    color: #aaa;
  }
  ul { 
    list-style: none;
  }
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  .contenedor-color-gris {        
        background-color: #9ea1a3;
        /*box-shadow: 0px 6px 20px 8px #161616;*/
        padding: 25px
    }

  .catalogoInformativo {
      pointer-events:none;
      cursor: not-allowed;
      opacity: 0.5;
  }  
</style>



// WEBPACK FOOTER //
// src/components/SIVAC/Firmas/EdicionProcesado.vue